import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  sideBarContainer: {
    position: 'relative',
    backgroundColor: ({BACKGROUND_COLOR}) => BACKGROUND_COLOR,
    height: 'auto',
    textAlign: 'right',
    padding: '40px 0px',
    [theme.breakpoints.down('md')]: {
      padding: '40px 0px',
      // height: 'auto'
    }
  },
  navLogo: {
    height: ({SIDEBAR}) => SIDEBAR.logo.height,
    width: ({SIDEBAR}) => SIDEBAR.logo.width,
    '&.href': {
      cursor: 'pointer'
    }
  },
  background: {
    position: 'absolute',
    top: 120,
    left: -100,
    '-webkit-animation': '$blur 10s ease 0s infinite',
    '-moz-animation': '$blur 10s ease 0s infinite',
    '-o-animation': '$blur 10s ease 0s infinite',
    'animation': '$blur 10s ease 0s infinite',
  },

  "@keyframes blur": {
    '0%': {
      '-webkit-filter': 'blur(0px)',
      '-moz-filter': 'blur(0px)',
      '-o-filter:': 'blur(0px)',
      '-ms-filter': 'blur(0px)',
    },
    '90%': {
      '-webkit-filter': 'blur(0px)',
      '-moz-filter': 'blur(0px)',
      '-o-filter:': 'blur(0px)',
      '-ms-filter': 'blur(0px)',
    },
    '50%': {
      '-webkit-filter': 'blur(20px)',
      '-moz-filter': 'blur(20px)',
      '-o-filter:': 'blur(20px)',
      '-ms-filter': 'blur(20px)',
    }
  },

  navDescription: {
    padding: '0px 60px',
    fontSize: 14,
    color: '#FFFFFF',
    textAlign: 'justify',
    textShadow: '0 0 10px #000000',
    whiteSpace: 'pre-wrap',
    // letterSpacing: '.15em',
    // animation: 'typing 3.5s steps(40, end), blink-caret .75s step-end infinite',
    [theme.breakpoints.down('md')]: {
      padding: '0px 40px',
    }
  },
  navDescriptionFooter: {
    padding: 20,
    fontSize: 12,
    color: '#FFFFFF',
    textAlign: 'right',
    textShadow: '0 0 10px #000000',
    whiteSpace: 'pre-wrap',
    position: 'absolute',
    bottom: 0,
    right: 0,
      // color: 'white',
      // textAlign: 'center',
    '& a': {
      color: ({ SEND_ICON_COLOR }) => SEND_ICON_COLOR
    }
  },
  navItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    '& .item': {
      textAlign: 'center',
      '&.logo': {
        padding: '10px 0 0 0'
      }
    },
    '& .navLink': {
      textTransform: 'none',
      fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
      borderRadius: 20,
      width: '90%',
      cursor: 'pointer',
      margin: '8px auto',
      padding: '7px 0',
      fontSize: 14,
      border: ({SIDEBAR}) => `1px solid ${SIDEBAR.borderColor}`,
      backgroundColor: ({SIDEBAR}) => SIDEBAR.backgroundColor,
      color: ({SIDEBAR}) => SIDEBAR.color,
      transition: '0.1s ease-in',
      '&:hover': {
        border: ({BUTTON}) => `1px solid ${BUTTON.hoverState.borderColor}`,
        backgroundColor: ({BUTTON}) => BUTTON.hoverState.backgroundColor,
        color: ({BUTTON}) => BUTTON.hoverState.color,
      },
      '&:active': {
        transform: 'translateY(4px)'
      },
      '&:disabled': {
        color: '#9e9e9e',
        border: '1px solid #9e9e9e'
      }
    }
  },
  navLogoBottom: {
    position: 'absolute',
    bottom: 12,
    left: 20,
    // bottom: ({SIDEBAR}) => SIDEBAR.enableEndChatButton?80:20,
    height: ({SIDEBAR}) => SIDEBAR.logoBottom?.height||'auto',
    width: ({SIDEBAR}) => SIDEBAR.logoBottom?.width||'auto',
    '&.href': {
      cursor: 'pointer'
    }
  },
  endButton: {
    position: 'absolute',
    left: '50%',
    border: ({SIDEBAR}) => `1px solid ${SIDEBAR.borderColor}`,
    borderRadius: 20,
    width: '60%',
    bottom: 20,
    transform: 'translate(-50%, -50%)',
    margin: '0 auto',
    fontSize: 14,
    color: ({SIDEBAR}) => SIDEBAR.color,
    textTransform: 'none',
    fontFamily: ({FONT_FAMILY}) => FONT_FAMILY,
    '& .fa-sign-out-alt': {
      marginLeft: 12
    },
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&:disabled': {
      border: `1px solid grey`
    }
  },
}));
